module.exports = __webpack_public_path__ + "img/milli.102229e.webp";